export default __webpack_public_path__ + "static/media/cif-ru.ba563cd4.svg";